import { PlayerSettingsUI } from "../PlayerSettings/PlayerSettings";
import { UpdateProjectSchemas } from "./ProjectSchemas";
import { IProjectModel } from "../../stores/project/projectModel";
import { Tabs, Divider } from "antd";
import "./ProjectSettings.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PATHS, PROJECT_PATHS, toPath } from "../../PATHS";
import { useEffect, useState } from "react";
import SceneOrLineupSelect from "../../components/SceneOrLineupSelect";
import { IFlowScene } from "@blings/blings-player/lib/src/SDK/sdk.api";

type Props = {
  project: IProjectModel;
};

export const ProjectSettings = ({ project }: Props) => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.endsWith(PROJECT_PATHS.settings)) {
      handleTabChange("playerSettings");
    }
  }, [location.pathname, navigate, params?.id]);

  const handleTabChange = (key: string) => {
    navigate(
      toPath(PATHS.project, params?.id || "", PROJECT_PATHS.settings, `${key}`)
    );
  };

  const [scenes, setScenes] = useState<IFlowScene[]>(() => {
    if (
      project.minisiteConfig.scenes &&
      project.minisiteConfig.scenes.length > 0
    ) {
      return project.minisiteConfig.scenes?.map((scene) => {
        try {
          return JSON.parse(scene);
        } catch (e) {
          return scene;
        }
      });
    }
    if (project?.flowDiagram?.lineups[0])
      return [{ lineup: project.flowDiagram.lineups[0] }];
    if (project.videoPartNames && project.videoPartNames.length > 0)
      return [project.videoPartNames[0]];
    return [];
  });

  const items = [
    {
      label: <span>Player</span>,
      key: "playerSettings",
      children: (
        <>
          <Divider className="tab-divider" />
          <PlayerSettingsUI project={project} scenes={scenes} />
        </>
      ),
    },
    {
      label: <span>Dynamic Data</span>,
      key: "dataSchema",
      children: (
        <>
          <Divider className="tab-divider" />
          <UpdateProjectSchemas project={project} />
        </>
      ),
    },
  ];

  const activeKey = params.subSettings ?? "playerSettings";

  return (
    <div className="project-settings">
      <Tabs
        className="settings-tabs"
        items={items}
        defaultActiveKey="playerSettings"
        activeKey={activeKey}
        onTabClick={handleTabChange}
      />

      {activeKey === "playerSettings" && (
        <div className="scene-selector">
          <span>Watching</span>
          <SceneOrLineupSelect
            flowDiagram={project.flowDiagram}
            scenes={project.videoPartNames || []}
            value={scenes}
            onChange={setScenes}
            className="view-live-version-select"
            limit={true}
          />
        </div>
      )}
    </div>
  );
};
